<script lang="ts">
    import {linear} from 'svelte/easing';

    import {duration as durationStore} from 'general/store';

    const scroll = (
        _: Node,
        {duration, direction}: {duration: number; direction: 'in' | 'out'},
    ) => ({
        duration,
        css: (t: number) =>
            `transform: translateY(${direction === 'out' ? '-' : ''}${100 - linear(t) * 100}%);`,
    });
</script>

<style module>
    .flip {
        position: absolute;
        width: 100%;
        height: 100%;
        backface-visibility: hidden;
        overflow: hidden;
    }
</style>

<div
    class="flip"
    in:scroll={{duration: $durationStore.flip.in, direction: 'in'}}
    out:scroll={{duration: $durationStore.flip.out, direction: 'out'}}
>
    <slot />
</div>
